import GenerateCampaignInput from '@Web/Src/Components/GenerateCampaignInput';
import SectionHeader from '@Web/Src/Components/SectionHeader';

const DemoInput = ({ className = '' }) => {
    return (
        <div className={`${className} large:px-0 mt-16 w-full`}>
            <div
                className={
                    'bg-builder bg-animated-slow bg-defaults bg-opacity relative flex w-full flex-col items-center overflow-hidden rounded-3xl !bg-[length:150%] px-6 py-16'
                }
            >
                <SectionHeader
                    type='light'
                    className='relative z-[1]'
                    icon='users'
                    title={__('Build a referral program')}
                />
                <GenerateCampaignInput className={'mt-12 w-full max-w-2xl'} />
            </div>
        </div>
    );
};

export default DemoInput;
